export default {
  'landing.nav_logo': 'Qpressen',
  'landing.nav_cta': 'Get Started',
  'landing.hero_title': 'Control Your Presentation\nwith a Single QR Code',
  'landing.hero_subtitle': 'Scan a QR code with your smartphone and start remote control instantly. No app installation needed — just your browser.',
  'landing.hero_cta': 'Get Started for Free',
  'landing.features_title': 'Powerful Features',
  'landing.features_subtitle': 'Everything you need for your presentation',
  'landing.feature_qr_title': 'QR Remote Control',
  'landing.feature_qr_desc': 'Scan a QR code and your smartphone becomes a remote. Use it instantly without installing any app.',
  'landing.feature_pdf_title': 'PDF Presentation',
  'landing.feature_pdf_desc': 'Upload a PDF file and it instantly converts to presentation mode.',
  'landing.feature_sketch_title': 'Sketch & Pointer',
  'landing.feature_sketch_desc': 'Draw on screen in real-time during your presentation and highlight with a pointer.',
  'landing.feature_notes_title': 'Speaker Notes',
  'landing.feature_notes_desc': 'View your presentation notes on your smartphone, invisible to the audience.',
  'landing.feature_share_title': 'Easy Sharing',
  'landing.feature_share_desc': 'Share your presentation with a single link and view it together in real-time.',
  'landing.feature_dashboard_title': 'Dashboard',
  'landing.feature_dashboard_desc': 'Manage and organize all your presentations in one place.',
  'landing.cta_title': 'Get Started Now',
  'landing.cta_subtitle': 'No complex setup needed. Experience a new way to present with just a QR code.',
  'landing.cta_button': 'Get Started for Free',
  'landing.footer_copyright': '© 2025 Qpressen. All rights reserved.',
  'landing.meta_title': 'Qpressen — Control your presentation with a QR code',
  'landing.meta_description': 'Scan a QR code with your smartphone and start remote control instantly. No app installation needed — just your browser.',
  'landing.og_description': 'Control your presentation with a single QR code',
};
